import React from 'react';
import * as Collapsible from '@radix-ui/react-collapsible';
import { ReactComponent as Layers } from 'assets/img/layers.svg';

export default function LayerToggleActions({ children, open, onOpenChange }) {
  return (
    <div data-component-name='LayerToggleActions'>
      <Collapsible.Root open={open} onOpenChange={(open) => onOpenChange(open)}>
        <Collapsible.Trigger className='flex gap-2.5 text-blue-500 text-base font-bold h-[60px] px-4 border-t border-solid border-blue-100 w-full items-center'>
          <Layers />
          Show/hide layers
        </Collapsible.Trigger>
        <Collapsible.Content className='pr-4 pb-9 pl-11'>{children}</Collapsible.Content>
      </Collapsible.Root>
    </div>
  );
}
